import api from './api';
import { ApiPermission, UpdatePermissionRequest } from '../types';

export const permissionService = {
  getKeyPermissions: (apiKeyId: number) => api.get<ApiPermission[]>(`/permissions/key/${apiKeyId}`),
  updatePermission: (id: number, data: UpdatePermissionRequest) => api.put(`/permissions/${id}`, data),
  bulkUpdate: (data: { apiKeyId: number; updates: any[] }) => api.post('/permissions/bulk-update', data),
};